import React from "react";
import { FUNNEL_OPTIONS, ALL_FUNNELS, VERTICAL_FUNNELS } from "@/lib/funnelOptions";

export const FunnelPicker = ({ value, onChange, disabled, testId = "funnel-picker" }) => {
  const toggle = (slug) => onChange(value.includes(slug) ? value.filter((s) => s !== slug) : [...value, slug]);
  const feedsFromInjury = !value.includes("injury") && value.some((v) => VERTICAL_FUNNELS.includes(v));
  return (
    <div data-testid={testId}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
        {FUNNEL_OPTIONS.map((f) => {
          const on = value.includes(f.slug);
          return (
            <label key={f.slug}
                   className={`border-2 border-black px-2 py-1.5 text-[11px] flex items-center gap-2 ${disabled ? "opacity-50" : "cursor-pointer"} ${on ? "bg-zinc-900 text-white" : "bg-white"}`}>
              <input type="checkbox" className="accent-black h-3.5 w-3.5" checked={on} disabled={disabled}
                     onChange={() => toggle(f.slug)} data-testid={`${testId}-${f.slug}`} />
              {f.title}
            </label>
          );
        })}
      </div>
      <div className="mt-1.5 flex flex-wrap items-center gap-3 text-[10px] text-zinc-600">
        <span data-testid={`${testId}-count`}>{value.length} of {ALL_FUNNELS.length} picked</span>
        {!disabled && (
          <button type="button" className="underline disabled:opacity-40" disabled={value.length === ALL_FUNNELS.length}
                  onClick={() => onChange([...ALL_FUNNELS])} data-testid={`${testId}-all`}>Pick all</button>
        )}
        {!value.length && <span className="text-red-700">Pick at least one funnel</span>}
      </div>
      {feedsFromInjury && (
        <div className="mt-1 text-[10px] text-zinc-600" data-testid={`${testId}-injury-note`}>
          Also gets matching {value.filter((v) => VERTICAL_FUNNELS.includes(v)).join(" / ")} cases from the Personal Injury (All-in-One) funnel.
        </div>
      )}
    </div>
  );
};
